import moment from 'moment-timezone'
import dayStartTime from './dayStartTime'
import totalDayMinutes from './totalDayMinutes'

export default ({ position, width }) =>
  moment(dayStartTime)
    .add((position / width) * totalDayMinutes, 'minutes')
    .toISOString()
